// Site Scheduling Frequency — shared row TYPE + frequency buckets.
//
// The screen is now DB-backed: GET /api/v1/site-scheduling-frequency returns
// each non-retired COC's schedule (COCSettings + lookups + best-effort
// recurrence); SiteSchedulingFrequencyPage maps those rows into SchedFreqRow.
// (The former static prototype array was removed once the live reader landed.)

export type FreqKey = 'm' | 'w' | 'bw' | 'sm' | 'q' | 'o' | 'review';

/** One scheduling-frequency obligation (one COC recurrence row). */
export interface SchedFreqRow {
  /** Stable, GUARANTEED-UNIQUE row key for the grid (React key / getRowId).
   *  COC_ID is NOT unique in the source (e.g. 0183, 0067 each recur), so it
   *  cannot be the row key — duplicate keys break the grid's sort/reorder
   *  reconciliation. Stamped at map time from cocId + the source index. */
  rk: string;
  cocId: string;
  name: string;
  isLabel: boolean;
  client: string;
  matrix: string;
  recurrence: string;
  freqKey: FreqKey;
  /** Real frequency label (Monthly/Weekly/Daily/Yearly/Unscheduled). Falls back
   *  to FREQ_LABEL[freqKey] when absent. */
  frequency?: string;
  tat: string;
  daysAdv: string;
  priority: string;
  nextUpcoming: string;
  status: string;
  projectId: string;
  projectName: string;
  projectCode: string;
}

/** Frequency bucket label + pill variant (order = chip order). */
export const FREQ_DEFS: { key: FreqKey; label: string; variant: string }[] = [
  { key: 'm',      label: 'Monthly',      variant: 'm' },
  { key: 'w',      label: 'Weekly',       variant: 'w' },
  { key: 'bw',     label: 'Biweekly',     variant: 'bw' },
  { key: 'sm',     label: 'Semi-monthly', variant: 'sm' },
  { key: 'q',      label: 'Quarterly',    variant: 'q' },
  { key: 'o',      label: 'Other',        variant: 'o' },
  { key: 'review', label: 'Unscheduled',  variant: 'review' },
];

export const FREQ_LABEL: Record<FreqKey, string> =
  Object.fromEntries(FREQ_DEFS.map((f) => [f.key, f.label])) as Record<FreqKey, string>;
